export default {
  badge: 'Huy hiệu',
  close: 'Đóng',
  dataIterator: {
    noResultsText: 'Không tìm thấy kết quả',
    loadingText: 'Đang tải dữ liệu...'
  },
  dataTable: {
    itemsPerPageText: 'Hàng trên mỗi trang:',
    ariaLabel: {
      sortDescending: 'Sắp xếp giảm dần.',
      sortAscending: 'Sắp xếp tăng dần.',
      sortNone: 'Không sắp xếp.',
      activateNone: 'Kích hoạt để loại bỏ sắp xếp.',
      activateDescending: 'Kích hoạt để sắp xếp giảm dần.',
      activateAscending: 'Kích hoạt để sắp xếp tăng dần.'
    },
    sortBy: 'Sắp xếp theo'
  },
  dataFooter: {
    itemsPerPageText: 'SL trên mỗi trang:',
    itemsPerPageAll: 'Tất cả',
    nextPage: 'Trang tiếp theo',
    prevPage: 'Trang trước',
    firstPage: 'Trang đầu tiên',
    lastPage: 'Trang cuối',
    pageText: '{0}-{1} of {2}'
  },
  datePicker: {
    itemsSelected: '{0} đã chọn',
    nextMonthAriaLabel: 'Tháng sau',
    nextYearAriaLabel: 'Năm sau',
    prevMonthAriaLabel: 'Tháng trước',
    prevYearAriaLabel: 'Năm trước'
  },
  noDataText: 'Không có dữ liệu',
  carousel: {
    prev: 'Hình ảnh trước đó',
    next: 'Hình ảnh tiếp theo',
    ariaLabel: {
      delimiter: '{0} của {1}'
    }
  },
  calendar: {
    moreEvents: '{0} thêm'
  },
  fileInput: {
    counter: '{0} tập tin',
    counterSize: '{0} tập tin ({1} trên tổng số)'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM'
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Điều hướng phân trang',
      next: 'Trang sau',
      previous: 'Trang trước',
      page: 'Đi đến trang {0}',
      currentPage: 'Trang hiện tại, trang {0}'
    }
  },
  rating: {
    ariaLabel: {
      icon: 'Đánh giá {0} của {1}'
    }
  }
}
